import { formatCurrency } from "lib/utils";
import MonthlySavings from "./monthly-savings";
import RestartButton from "../common/restart-button";
import CtaBanner from "../common/cta-banner";
import styles from "./results.module.css";

interface FormData {
  age: number | null;
  ageEnd: number | null;
  monthlyExpense: number | null;
  emergencyFund: number | null;
}

interface ResultsProps {
  formData: FormData;
}

const Results = ({ formData }: ResultsProps) => {
  const inflationRate = 0.02;
  const totalLifeExpectancy = 83;

  // Convert selectedReturnRate to a number
  const getReturnRateValue = (rate: string): number => {
    switch (rate) {
      case "0.05%":
        return 0.0005;
      case "3%":
        return 0.03;
      case "8%":
        return 0.08;
      default:
        return 0;
    }
  };

  // Calculate years in retirement
  const yearsInRetirement =
    formData.ageEnd !== null ? totalLifeExpectancy - formData.ageEnd : 0;

  // Calculate required savings
  const requiredSavings =
    formData.monthlyExpense !== null && formData.emergencyFund !== null
      ? (formData.monthlyExpense *
          12 *
          (Math.pow(1 + inflationRate, yearsInRetirement) - 1)) /
          inflationRate +
        formData.emergencyFund
      : 0;

  // Calculate monthly savings for each rate
  const rates = ["0.05%", "3%", "8%"];
  const monthlySavings = rates.map((rate) => {
    const returnRate = getReturnRateValue(rate);
    const monthlyIR = returnRate / 12;

    const yearsToSave =
      formData.age !== null && formData.ageEnd !== null
        ? (formData.ageEnd - formData.age) * 12
        : 0;

    return yearsToSave > 0 && monthlyIR > 0
      ? requiredSavings /
          ((Math.pow(1 + monthlyIR, yearsToSave) - 1) / monthlyIR)
      : 0;
  });

  return (
    <div className={styles.resultsContainer}>
      <div className={styles.textCenter}>
        <span className={styles.block}>
          By age {formData.ageEnd}, for your desired retirement, you will need
          up to:
        </span>
        <h2 className={styles.fontBold}>{formatCurrency(requiredSavings)}</h2>
      </div>

      <MonthlySavings monthlySavings={monthlySavings} />

      <CtaBanner page="retirement" />

      <RestartButton />
    </div>
  );
};

export default Results;
